// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_NU5","cls2":"SearchBar-cls2_1hf SearchBar-cls1_NU5"};